import { Button } from "@/components/ui/button";
import { formatCredentialTimestamp } from "@/features/credentials/lib/format-date";
import {
  isRunActive,
  isRunCancelled,
  type RunReport,
} from "@/features/credentials/components/primary-source-runs/types";
import { StartedRunNotice } from "../provider-page-search";

/** Plain notices above the report: what starting the run reported, and which
 * earlier run is on screen when it is not the latest. */
export function VerificationNotices({
  data,
  notice,
  isHistorical,
  canEdit,
  onViewLatest,
}: {
  data: RunReport | undefined;
  notice?: StartedRunNotice;
  isHistorical: boolean;
  canEdit: boolean;
  onViewLatest: () => void;
}) {
  const showStartNotice = !data || isRunActive(data.run);
  return (
    <>
      {notice === StartedRunNotice.DispatchPending && showStartNotice && (
        <p role="status" className="text-sm text-muted-foreground">
          Your request was saved and is waiting to start. It will retry
          automatically.
        </p>
      )}
      {notice === StartedRunNotice.Reused && showStartNotice && (
        <p className="text-sm text-muted-foreground">
          Showing the verification already in progress for this provider.
        </p>
      )}
      {isHistorical && data && (
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm">
          <p>
            {isRunCancelled(data.run)
              ? "Showing a cancelled run"
              : "Showing an earlier run"}{" "}
            requested {formatCredentialTimestamp(data.run.createdAt)}. The
            status above is from the latest run.
            {canEdit && " This run’s review decisions are read-only."}
          </p>
          <Button variant="outline" size="sm" onClick={onViewLatest}>
            View latest report
          </Button>
        </div>
      )}
    </>
  );
}
